import React, { Component } from 'react';
import { formatAmount } from 'src/Common/utils';
import Filters from '../Filters';
import Card from './Card';


export default class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showFilters: false
        };
        this.handleFiltersButtonClick = this.handleFiltersButtonClick.bind(this);
    }

    handleFiltersButtonClick() {
        const { showFilters } = this.state;
        this.setState({
            showFilters: !showFilters
        });
    }

    render() {
        const { showFilters } = this.state;
        const { loading, error, data } = this.props;

        let {
          sumAll,
          sumCommissionsOperators,
          sumCommissionsEstablishments,
          sumCommissionsPortalusers
        } = data || 0


        return (
            <div className="header bg-gradient-default pb-8 pt-5 pt-md-8">
                <div className="container-fluid">
                    <div className="header-body">
                        <div className="row align-items-center py-4">
                            <div className="col-lg-6 col-7">
                                <h6 className="h2 text-white d-inline-block mb-0">Repasses</h6>
                                <div>
                                    <a
                                        href="javascript:void(0)"
                                        className="h4 pt-2 text-white"
                                        onClick={this.handleFiltersButtonClick}>
                                            <i className="fas fa-filter mr-2 text-sm" />
                                            Filtrar
                                    </a>
                                </div>
                            </div>
                            { showFilters &&
                                <Filters />
                            }
                        </div>
                        <div className="row">
                            <div className="col">
                                <Card
                                    loading={false}
                                    bgColor="bg-success"
                                    title="Valores dos repasses"
                                    topUpperTitle="Valor total"
                                    topUpperValue={formatAmount(sumAll)}
                                    leftUpperTitle="Operadores"
                                    leftUpperValue={formatAmount(sumCommissionsOperators)}
                                    centerUpperTitle="Estabelecimentos"
                                    centerUpperValue={formatAmount(sumCommissionsEstablishments)}
                                    rightUpperTitle="Vendedores"
                                    rightUpperValue={formatAmount(sumCommissionsPortalusers)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/CommissionsTransfers/Header/index.js